module.exports = __webpack_public_path__ + "static/hojae_lee-84656d15d4f1863090c9e3089064a6c3.jpg";